import { colors } from './colors';
import { fonts, spacing } from './fonts';

export const tableStyles = {
  header: {
    fontWeight: fonts.weightSemiBold,
    fontSize: fonts.fontSizeXs,
    letterSpacing: '0.02em',
    color: colors.textWhite,
    backgroundColor: colors.primaryDark,
    borderBottom: 'none',
    py: '6px',
    px: '10px',
  },
  cell: {
    fontSize: fonts.fontSizeXs,
    color: colors.textPrimaryDark,
    py: '6px',
    px: '10px',
    borderBottom: `1px solid ${colors.borderLight}`,
  },
  row: {
    height: '36px',
  },
  denseChip: {
    fontSize: fonts.fontSizeXxs,
    fontWeight: fonts.weightSemiBold,
    letterSpacing: '0.02em',
  },
  pagination: {
    fontSize: fonts.fontSizeXs,
    color: colors.textPrimaryDark,
    py: spacing.xs,
  },
};

